import { UserRole } from '../users/roles';

export const loggedAsBrand = (userRole?: UserRole) =>
  userRole && (userRole === 'ADMIN_MARCA' || userRole === 'VENDEDOR');

export const loggedAsStore = (userRole?: UserRole) =>
  userRole && (userRole === 'ADMIN_LOJA' || userRole === 'COMPRADOR');
